import React from "react";
import { useTranslation } from "react-i18next";
import ModalLayout from "app/components/Layouts/ModalLayout/ModalLayout";
import styles from "./styles.module.scss";

interface UnsavedChangesModalProps {
  isOpen: boolean;
  /** Persist the edits, then continue navigation (parent handles the await). */
  onSave: () => void;
  /** Drop the edits and continue navigation. */
  onDiscard: () => void;
  /** Stay on the page. */
  onCancel: () => void;
  /** Disables buttons and shows a spinner on Save while a save is in flight. */
  saving?: boolean;
}

export default function UnsavedChangesModal({
  isOpen,
  onSave,
  onDiscard,
  onCancel,
  saving = false,
}: UnsavedChangesModalProps) {
  const { t } = useTranslation();

  if (!isOpen) {
    return null;
  }

  return (
    <ModalLayout isOpen onClose={onCancel} classNames={styles.modal}>
      <div className={styles.content}>
        <div className={styles.close_button} onClick={onCancel}>
          <i className="ico ico-x" />
        </div>
        <h2 className={styles.title}>{t("Unsaved changes")}</h2>
        <div className={styles.body}>
          {t(
            "You have unsaved changes. Do you want to save them before leaving?"
          )}
        </div>
        <div className={styles.actions}>
          <button
            type="button"
            className="btn btn-primary"
            onClick={onSave}
            disabled={saving}
          >
            {saving ? <span className={styles.spinner} /> : t("Save changes")}
          </button>
          <button
            type="button"
            className="btn btn-secondary"
            onClick={onDiscard}
            disabled={saving}
          >
            {t("Discard changes")}
          </button>
          <button
            type="button"
            className={`btn ${styles.cancel_button}`}
            onClick={onCancel}
            disabled={saving}
          >
            {t("Cancel")}
          </button>
        </div>
      </div>
    </ModalLayout>
  );
}
